import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";

import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStudent } from "../../store/slices/student";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";


export default function StudentId() {

  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});

  const [standardId, setStandardId] = useState("");
  const [studentId, setStudentId] = useState("");
  const [sectionId, setSectionId] = useState("");

  const [isGenerating, setIsGenerating] = useState(false);

  const [standards, setStandards] = useState([]);
  const [students, setStudents] = useState([]);
  const [sections, setSections] = useState([]);


  useEffect(() => {

    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {

        setStandards(res.data || []);

      })
      .catch((err) => {

        toast.error(
          err?.message ||
          err ||
          "Failed to fetch standards"
        );

      });

  }, [dispatch]);


  const validate = () => {

    const newErrors = {};

    if (!standardId) {
      newErrors.standardId = "Please select standard";
    }

    if (!sectionId) {
      newErrors.sectionId = "Please select section";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };


  const handleStandardChange = (e) => {

    const value = e.target.value;

    setStandardId(value);

    setSectionId("");
    setStudentId("");

    setStudents([]);


    const selectedStandard = standards.find(
      item => item.standardId._id === value
    );

    if (selectedStandard) {

      setSections(
        selectedStandard.sectionId || []
      );

    } else {

      setSections([]);

    }

  };


  const handleSectionChange = (e) => {

    const value = e.target.value;

    setSectionId(value);

    setStudentId("");

    setStudents([]);


    dispatch(
      getStudent({
        standardId,
        sectionId: value
      })
    )
      .unwrap()
      .then((res) => {

        setStudents(
          Array.isArray(res?.data)
            ? res.data
            : []
        );

      })
      .catch((err) => {

        toast.error(
          err?.message ||
          err ||
          "Failed to fetch students"
        );

      });

  };


  const handleStudentChange = (e) => {

    setStudentId(
      e.target.value
    );

  };


  /*
   * ==========================================
   * WAIT FOR IMAGES
   * ==========================================
   */

  const waitForImages = async (container) => {

    const images = Array.from(
      container.querySelectorAll("img")
    );

    await Promise.all(

      images.map((img) => {

        if (img.complete) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {

          img.onload = resolve;
          img.onerror = resolve;

        });

      })

    );

  };


  /*
   * ==========================================
   * CREATE HTML ID CARD
   * ==========================================
   */

  const createIdCard = (
    student,
    institute
  ) => {

    const card = document.createElement("div");

    card.style.width = "350px";
    card.style.height = "510px";

    card.style.background = "#ffffff";

    card.style.border = "1.5px solid #165A36";

    card.style.borderRadius = "12px";

    card.style.overflow = "hidden";

    card.style.display = "flex";

    card.style.flexDirection = "column";

    card.style.fontFamily = "Arial, sans-serif";

    card.style.boxSizing = "border-box";


    const standardName =
      student?.standardId?.name || "";

    const sectionName =
      student?.sectionId?.name || "";

    const classSection = [
      standardName,
      sectionName
    ]
      .filter(Boolean)
      .join(" - ");


    const address =
      student?.presentAddress ||
      student?.permanentAddress ||
      "";

    const header =
      document.createElement("div");

    header.style.height = "80px";

    header.style.background = "#165A36";

    header.style.display = "flex";

    header.style.alignItems = "center";

    header.style.justifyContent = "center";

    header.style.padding = "0 5px";

    header.style.boxSizing = "border-box";


    const schoolName =
      document.createElement("div");

    schoolName.innerText =
      institute?.instituteName || "";

    schoolName.style.color = "#D4B15A";

    schoolName.style.fontSize = "30px";

    schoolName.style.fontWeight = "bold";

    schoolName.style.textAlign = "center";

    schoolName.style.fontFamily = "Georgia, 'Times New Roman', serif";
    schoolName.style.lineHeight = "32px";
    header.appendChild(schoolName);

    card.appendChild(header);



    const idTitle =
      document.createElement("div");

    idTitle.style.height = "35px";

    idTitle.style.background = "#D4B15A";

    idTitle.style.display = "flex";

    idTitle.style.alignItems = "center";

    idTitle.style.justifyContent = "center";


    const idTitleText =
      document.createElement("div");

    idTitleText.innerText =
      "STUDENT ID CARD";

    idTitleText.style.fontSize = "18px";

    idTitleText.style.fontWeight = "bold";

    idTitleText.style.color = "#111111";


    idTitle.appendChild(idTitleText);

    card.appendChild(idTitle);


    /*
     * ======================================
     * BODY
     * ======================================
     */

    const body =
      document.createElement("div");

    body.style.flex = "1";

    body.style.display = "flex";

    body.style.flexDirection = "column";

    body.style.alignItems = "center";

    body.style.paddingTop = "15px";

    body.style.boxSizing = "border-box";


    /*
     * PHOTO
     */

    const photoContainer =
      document.createElement("div");

    photoContainer.style.width = "120px";

    photoContainer.style.height = "120px";

    photoContainer.style.border = "2px solid #165A36";

    photoContainer.style.borderRadius = "10px";

    photoContainer.style.padding = "4px";

    photoContainer.style.boxSizing = "border-box";

    photoContainer.style.display = "flex";

    photoContainer.style.alignItems = "center";

    photoContainer.style.justifyContent = "center";


    if (student?.image) {

      const image =
        document.createElement("img");

      image.src = student.image;

      image.crossOrigin = "anonymous";

      image.style.width = "100%";

      image.style.height = "100%";

      image.style.objectFit = "cover";

      image.style.borderRadius = "7px";


      photoContainer.appendChild(image);

    } else {

      const noPhoto =
        document.createElement("div");

      noPhoto.innerText = "PHOTO";

      noPhoto.style.width = "100%";

      noPhoto.style.height = "100%";

      noPhoto.style.background = "#eeeeee";

      noPhoto.style.borderRadius = "7px";

      noPhoto.style.display = "flex";

      noPhoto.style.alignItems = "center";

      noPhoto.style.justifyContent = "center";

      noPhoto.style.color = "#777777";

      noPhoto.style.fontSize = "12px";


      photoContainer.appendChild(noPhoto);

    }


    body.appendChild(photoContainer);


    /*
     * STUDENT NAME
     */

    const name =
      document.createElement("div");

    name.innerText =
      student?.name || "";

    name.style.fontSize = "20px";

    name.style.fontWeight = "bold";

    name.style.color = "#8D244D";

    name.style.textAlign = "center";

    name.style.marginTop = "8px";

    name.style.padding = "0 8px";


    body.appendChild(name);


    /*
     * CLASS
     */

    const classText =
      document.createElement("div");

    classText.innerText =
      classSection;

    classText.style.fontSize = "18px";

    classText.style.fontWeight = "bold";

    classText.style.color = "#357347";

    classText.style.marginTop = "4px";

    classText.style.textAlign = "center";


    body.appendChild(classText);


    /*
     * DETAILS
     */

    const details =
      document.createElement("div");

    details.style.width = "90%";

    details.style.marginTop = "14px";

    details.style.textAlign = "center";

    details.style.color = "#111111";


    if (address) {

      const addressText =
        document.createElement("div");

      addressText.innerText =
        address;

      addressText.style.fontSize = "14px";

      addressText.style.fontWeight = "bold";

      addressText.style.lineHeight = "1.2";

      addressText.style.marginTop = "3px";


      details.appendChild(addressText);

    }


    if (student?.parentId?.fatherMobileNo) {

      const phone =
        document.createElement("div");

      phone.innerText =
        `Ph: ${student.parentId.fatherMobileNo}`;

      phone.style.fontSize = "14px";

      phone.style.fontWeight = "bold";

      phone.style.marginTop = "3px";


      details.appendChild(phone);

    }


    body.appendChild(details);

    card.appendChild(body);


    /*
     * ======================================
     * FOOTER
     * ======================================
     */

    const footer =
      document.createElement("div");

    footer.style.height = "85px";

    footer.style.background = "#165A36";

    footer.style.color = "#ffffff";

    footer.style.display = "flex";

    footer.style.flexDirection = "column";

    footer.style.alignItems = "center";

    footer.style.justifyContent = "center";

    footer.style.padding = "5px 8px";

    footer.style.boxSizing = "border-box";


    const footerAddress =
      document.createElement("div");

    footerAddress.innerText =
      institute?.instituteAddress || "";

    footerAddress.style.fontSize = "12px";

    footerAddress.style.fontWeight = "bold";

    footerAddress.style.textAlign = "center";


    footer.appendChild(
      footerAddress
    );


    const contact =
      document.createElement("div");

    contact.innerText =
      `Ph: ${institute?.instituteMobileNo || ""} | Email: ${institute?.instituteEmail || ""}`;

    contact.style.fontSize = "10px";

    contact.style.fontWeight = "normal";

    contact.style.marginTop = "3px";

    contact.style.textAlign = "center";

    contact.style.width = "100%";

    footer.appendChild(contact);


    const website =
      document.createElement("div");

    website.innerText =
      institute?.instituteWebsite || "";

    website.style.fontSize = "12px";

    website.style.fontWeight = "normal";

    website.style.marginTop = "2px";

    website.style.textAlign = "center";


    footer.appendChild(website);


    card.appendChild(footer);


    return card;

  };


  /*
   * ==========================================
   * GENERATE PDF
   * ==========================================
   */

  const generateIdCardPDF = async (
    studentsData,
    instituteData
  ) => {

    /*
     * Temporary container
     * outside the visible UI.
     */

    const container =
      document.createElement("div");

    container.style.position = "fixed";

    container.style.left = "-10000px";

    container.style.top = "0";

    container.style.width = "350px";

    container.style.background = "#ffffff";

    container.style.zIndex = "-1";


    document.body.appendChild(container);


    try {

      /*
       * Create cards
       */

      const cards =
        studentsData.map((student) => {

          const card =
            createIdCard(
              student,
              instituteData
            );

          container.appendChild(card);

          return card;

        });


      /*
       * Wait for S3 images
       */

      await waitForImages(
        container
      );


      /*
       * Create A4 landscape PDF
       */

      const pdf =
        new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4"
        });


      const pageWidth =
        pdf.internal.pageSize.getWidth();

      const pageHeight =
        pdf.internal.pageSize.getHeight();


      /*
       * ======================================
       * 4 X 2 GRID
       * ======================================
       */

      const marginX = 7;

      const marginY = 7;

      const gapX = 5;

      const gapY = 5;


      const cardWidth =
        (pageWidth -
          marginX * 2 -
          gapX * 3) / 4;


      const cardHeight =
        (pageHeight -
          marginY * 2 -
          gapY) / 2;


      /*
       * ======================================
       * EACH PAGE = 8 CARDS
       * ======================================
       */

      for (
        let i = 0;
        i < cards.length;
        i++
      ) {

        /*
         * New page after every 8 cards
         */

        if (
          i > 0 &&
          i % 8 === 0
        ) {

          pdf.addPage();

        }


        const position =
          i % 8;


        const column =
          position % 4;


        const row =
          Math.floor(position / 4);


        const x =
          marginX +
          column *
          (cardWidth + gapX);


        const y =
          marginY +
          row *
          (cardHeight + gapY);


        /*
         * Capture card
         */

        const canvas = await html2canvas(
          cards[i],
          {
            scale: 1.3,
            useCORS: true,
            allowTaint: false,
            backgroundColor: "#ffffff",
            logging: false
          }
        );

        const image = canvas.toDataURL(
          "image/jpeg",
          0.75
        );

        pdf.addImage(
          image,
          "JPEG",
          x,
          y,
          cardWidth,
          cardHeight,
          undefined,
          "FAST"
        );

      }


      /*
       * Download
       */

      pdf.save(
        "student-id-cards.pdf"
      );

    } finally {

      /*
       * Remove temporary cards
       */

      document.body.removeChild(
        container
      );

    }

  };


  /*
   * ==========================================
   * SEARCH / GENERATE
   * ==========================================
   */

  const handleSearch = async (e) => {

    e?.preventDefault();

    if (!validate()) {
      return;
    }

    setIsGenerating(true);

    try {

      const payload = {
        standardId,
        sectionId,
      };


      if (studentId) {

        payload.id =
          studentId;

      }


      const response =
        await dispatch(
          getStudent(payload)
        ).unwrap();


      console.log(
        "GET STUDENT RESPONSE:",
        response
      );


      const studentsData =
        Array.isArray(response?.data)
          ? response.data
          : [];


      const instituteData =
        response?.institute || {};


      if (!studentsData.length) {

        toast.error(
          "No students found"
        );

        return;

      }


      await generateIdCardPDF(
        studentsData,
        instituteData
      );


      toast.success(
        "ID card PDF generated successfully"
      );

    } catch (err) {

      console.error(
        "STUDENT ID CARD ERROR:",
        err
      );

      toast.error(
        err?.message ||
        err ||
        "Failed to generate ID card"
      );

    } finally {

      setIsGenerating(false);

    }

  };


  return (
    <>

      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">

            <div className="home-icon">

              <Link to="/accounts/home">

                <FiHome
                  style={{
                    color: "white",
                    marginTop: "-4px"
                  }}
                />

              </Link>

            </div>

            <FiChevronRight
              className="separator"
            />

            <span className="active">
              Student ID Card
            </span>

          </div>

        </div>

      </div>


      <div className="acs-card">

        <Form onSubmit={handleSearch}>

          <Row className="g-3">

            {/* STANDARD */}

            <Col md={3}>

              <Form.Group>

                <Form.Label>
                  Standard
                </Form.Label>

                <Form.Select
                  value={standardId}

                  onChange={(e) => {

                    handleStandardChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      standardId: ""
                    }));

                  }}
                >

                  <option value="">
                    Select Standard
                  </option>

                  {standards.map((item) => (

                    <option
                      key={item.standardId._id}
                      value={item.standardId._id}
                    >
                      {item.standardId.name}
                    </option>

                  ))}

                </Form.Select>

                {errors.standardId && (

                  <div className="text-danger mt-1">
                    {errors.standardId}
                  </div>

                )}

              </Form.Group>

            </Col>


            {/* SECTION */}

            <Col md={3}>

              <Form.Group>

                <Form.Label>
                  Section
                </Form.Label>

                <Form.Select
                  value={sectionId}
                  disabled={!standardId}

                  onChange={(e) => {

                    handleSectionChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      sectionId: ""
                    }));

                  }}
                >

                  <option value="">
                    Select Section
                  </option>

                  {sections.map((item) => (

                    <option
                      key={item._id}
                      value={item._id}
                    >
                      {item.name}
                    </option>

                  ))}

                </Form.Select>

                {errors.sectionId && (

                  <div className="text-danger mt-1">
                    {errors.sectionId}
                  </div>

                )}

              </Form.Group>

            </Col>


            {/* STUDENT */}

            <Col md={3}>

              <Form.Group>

                <Form.Label>
                  Student
                </Form.Label>

                <Form.Select
                  value={studentId}
                  disabled={!sectionId}

                  onChange={handleStudentChange}
                >

                  <option value="">
                    All Student
                  </option>

                  {students.map((item) => (

                    <option
                      key={item._id}
                      value={item._id}
                    >
                      {item.name}
                    </option>

                  ))}

                </Form.Select>

              </Form.Group>

            </Col>

          </Row>


          <Row className="mt-5">

            <Col className="d-flex justify-content-center">

              <button
                type="button"
                className="btn-submit"
                style={{
                  width: "150px"
                }}
                onClick={handleSearch}
                disabled={isGenerating}
              >

                {isGenerating
                  ? "Preparing..."
                  : "Generate PDF"}

              </button>

            </Col>

          </Row>

        </Form>

      </div>

    </>
  );
}